import { supabase } from '../../lib/supabase';

export type ContactExportFormat = 'csv' | 'xlsx';

interface ExportContactsOptions {
    organizationId: string;
    contactIds?: string[];
    format?: ContactExportFormat;
}

function parseFilename(contentDisposition: string | null, fallback: string): string {
    if (!contentDisposition) return fallback;
    const match = contentDisposition.match(/filename="([^"]+)"/);
    return match?.[1] || fallback;
}

function triggerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

/**
 * Exporta contatos via Edge Function (tenant-scoped, RLS no servidor).
 */
export async function exportContacts({
    organizationId,
    contactIds,
    format = 'csv',
}: ExportContactsOptions): Promise<void> {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) {
        throw new Error('Sessão expirada. Faça login novamente.');
    }

    const params = new URLSearchParams({
        organizationId,
        format,
    });

    if (contactIds && contactIds.length > 0) {
        params.set('ids', contactIds.join(','));
    }

    const baseUrl = import.meta.env.VITE_SUPABASE_URL;
    const res = await fetch(`${baseUrl}/functions/v1/export-contacts?${params.toString()}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${session.access_token}`,
        },
    });

    if (!res.ok) {
        const payload = await res.json().catch(() => ({}));
        throw new Error(payload.error || 'Falha ao exportar contatos.');
    }

    const blob = await res.blob();
    const filename = parseFilename(
        res.headers.get('Content-Disposition'),
        `contatos.${format === 'xlsx' ? 'xlsx' : 'csv'}`
    );
    triggerDownload(blob, filename);
}
